import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import * as formViews from "./constants/formViews";
import { selectRegistrationAccount } from "../../../redux/slices/registrationAccountSlice";
import ResetPasswordEmailButton from "./ResetPasswordEmailButton";

const ConnectedResetPasswordEmailButton = () => {
    const registrationAccount = useSelector(selectRegistrationAccount);
    const {
        form: { formView },
        resetPasswordLinkStatus = "",
    } = registrationAccount;
    const {
        ENUMS: { Status },
    } = constants;

    // If the user is on the sign in screen display the need help with password
    // button but if the user is on the reset password screen and the reset
    // password page is invalid because the reset password link is used or
    // expired display the send another link button
    const displayNeedHelpWithPasswordButton = formView === formViews.SIGN_IN;
    const displaySendAnotherLinkButton =
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.USED) ||
        (formView === formViews.RESET_PASSWORD &&
            resetPasswordLinkStatus === Status.EXPIRED);

    return (
        <ResetPasswordEmailButton
            displayNeedHelpWithPasswordButton={
                displayNeedHelpWithPasswordButton
            }
            displaySendAnotherLinkButton={displaySendAnotherLinkButton}
        />
    );
};

export default ConnectedResetPasswordEmailButton;
